var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08122 10.2907L8.08122 2.2634",
    stroke: "#714FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 8.33893L8.08139 10.2909L6.13739 8.33893",
    stroke: "#714FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17 5.41866H11.792C13.1487 5.41866 14.248 6.51799 14.248 7.87532L14.248 11.1313C14.248 12.4847 13.1514 13.5813 11.798 13.5813L4.37138 13.5813C3.01471 13.5813 1.91471 12.4813 1.91471 11.1247L1.91471 7.86799C1.91471 6.51532 3.01205 5.41866 4.36471 5.41866H4.99271",
    stroke: "#714FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.bdee6e857e798e1c90a2e4e2c9c914cb.svg";
export { ForwardRef as ReactComponent };